var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-skeleton"),
      _vm._v(" "),
      _c("b-skeleton", { attrs: { width: "10rem", height: "0.8rem" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "calendar-popover-body mt-2" },
        [
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "text-center pr-0", attrs: { cols: "1" } },
                [
                  _c("i", {
                    staticClass:
                      "text-primary fa fa-clock-o task-calendar-icon",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "vertical-center", attrs: { cols: "11" } },
                [_c("b-skeleton", { attrs: { width: "100%" } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "text-center pr-0", attrs: { cols: "1" } },
                [
                  _c("i", {
                    staticClass:
                      "text-primary fa fa-map-marker task-calendar-icon",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "vertical-center", attrs: { cols: "11" } },
                [_c("b-skeleton", { attrs: { width: "100%" } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "text-center pr-0", attrs: { cols: "1" } },
                [
                  _c("i", {
                    staticClass:
                      "text-primary fa fa-align-justify task-calendar-icon",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "vertical-center", attrs: { cols: "11" } },
                [
                  _c("b-skeleton", {
                    attrs: { width: "100%", height: "5rem" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "text-center pr-0", attrs: { cols: "1" } },
                [
                  _c("i", {
                    staticClass: "text-primary fa fa-users task-calendar-icon",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "11" } },
                [
                  _c("b-skeleton", { attrs: { width: "100%" } }),
                  _vm._v(" "),
                  _c("b-skeleton", { attrs: { width: "100%" } }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }